import { useEffect } from 'react';
import { setIn } from 'formik';

import cancelablePromise from '../utilities/cancelablePromise';

function useFormApi(promise, ...rest) {
    let pendingPromises = [];

    if (!promise) return;

    const apiCall = (form, ...args) => {
        const pendingPromise = promise(...rest, ...args);
        const wrappedPromise = cancelablePromise(pendingPromise);

        wrappedPromise
            .catch(error => {
                let formErrors = {};

                if (error.response && error.response.data) {
                    Object.keys(error.response.data).forEach(fieldPath => {
                        formErrors = setIn(formErrors, fieldPath, error.response.data[fieldPath]);
                    });
                }

                form.setSubmitting(false);
                form.setErrors(formErrors);
            })
            .finally(() => {
                pendingPromises = pendingPromises.filter(p => p !== wrappedPromise);
            });

        pendingPromises.push(wrappedPromise);

        return wrappedPromise;
    };

    useEffect(() => {
        return () => pendingPromises.map(p => p.cancel());
    }, [promise]);

    return apiCall;
}

export default useFormApi;
